import distanceInWords from 'date-fns/distance_in_words_to_now'
import relativeSuffix from './relativeSuffix'

export default (date) => {
  return distanceInWords(date) + ' ' + relativeSuffix(date)
}
